import { Box } from '@packages/shared';
import type { CmsData } from '@packages/cms-components/interfaces/webapp_json';
import { CmsAccordionTestIds, CmsGeneralAccordion } from '@packages/cms-components';
import ComponentRecognizerFooter from './ComponentRecognizerFooter';
import type { FooterBlockType } from './types';

type FooterAccordionProps = {
  data: CmsData;
};

const FooterAccordion = ({ data }: FooterAccordionProps): JSX.Element => {
  const comp = (data.paragraph as FooterBlockType[])
    ?.filter((item) => item?.parent_field_name === 'field_footer')
    ?.map((item) => ({
      id: `footer-accordion-${item.id}`,
      headline: item.field_headline,
      isOpen: item.field_is_open,
      content: <ComponentRecognizerFooter item={item} />,
    }));

  return (
    <Box
      sx={{
        width: '100%',
        margin: 0,
        padding: 0,
        '& .layout-variant-inline': {
          width: 'auto',
          display: 'flex',
          alignContent: 'center',
          flexShrink: 0,
          verticalAlign: 'top',
        },
        '& .footer_block_badges': {
          display: 'flex',
          gap: 1.6,
        },
      }}
      data-testid={CmsAccordionTestIds.main}
    >
      <CmsGeneralAccordion entries={comp} highlightOpen={false} />
    </Box>
  );
};

// eslint-disable-next-line import/no-default-export
export default FooterAccordion;
